import {utilHelper} from '../../_helpers';

const relativeUrl = 'api/module'

export const moduleService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    search,
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET');
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

function deleteItem(id, _) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', {});
}


